import React from "react";
import reqLayout from "../../_common/hoc/layout";
import AICandidateSearchMain from "../../components/ai-candidate-search/AICandidateSearchMain";
import Sidebar from "../../components/common/Sidebar";
import { RODEO_PAGE_NAME } from "../../_config";
import Header from "src/components/common/Header";
import Footer from "src/components/common/Footer";

const AICandidateSearchPage: React.FC = () => {
  return (
    <>
     <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.AI_CANDIDATE_SEARCH} />
      <AICandidateSearchMain />
      <Footer variant="dashboard" />
    </>
  );
};

export default reqLayout(AICandidateSearchPage);
